import React, { useEffect, useState } from 'react';
import { IconButton, Box, makeStyles } from '@material-ui/core';
import { getCustomColors } from '../../styles/CustomColors';
import { COLOR_WHITE } from '../utilities/MaterialWatchman';
import { Close } from '@material-ui/icons';

const Colors = getCustomColors();

function debounce(fn, ms) {
    let timer
    return _ => {
        clearTimeout(timer)
        timer = setTimeout(_ => {
            timer = null
            fn.apply(this, arguments)
        }, ms)
    };
}

const useStyles = makeStyles(theme => ({
    fullImage: {
        width: '100%',
        height: '100%',
        position: 'fixed',
        zIndex: 10003,
        backgroundColor: Colors.BACKGROUND_COLOUR_WITH_TRANSPARENCY,
        top: 0,
        left: 0,
    },
    imageContainer: {
        position: 'relative',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        height: '100%',
        width: '100%',
    },
    image: {
        display: 'block',
        height: 'auto',
        width: 'auto',
    },
    close: {
        position: 'absolute',
        top: theme.spacing(1),
        right: theme.spacing(1),
        backgroundColor: COLOR_WHITE,
        borderRadius: '50%',
        width: theme.spacing(5),
        height: theme.spacing(5),
        padding: theme.spacing(1),
        '& svg': {
            width: theme.spacing(5),
            height: theme.spacing(5),
        },
    },
}));

const FullscreenImageView = ({ url, onClose }) => {
    const classes = useStyles();

    const closeFullscreen = () => {
        onClose && onClose();
    }

    const [dimensions, setDimensions] = useState({
        height: window.innerHeight,
        width: window.innerWidth
    })

    useEffect(() => {
        const debouncedHandleResize = debounce(function handleResize() {
            setDimensions({
                height: window.innerHeight,
                width: window.innerWidth
            })
        }, 500);

        window.addEventListener('resize', debouncedHandleResize);

        return _ => {
            window.removeEventListener('resize', debouncedHandleResize);
        }
    }, []);

    return (
        <Box className={classes.fullImage}>
            <Box className={classes.imageContainer}>
                <img alt="full" style={{ maxWidth: dimensions.width, maxHeight: dimensions.height }} className={classes.image} src={url} />
                <IconButton onClick={closeFullscreen} type="button" className={classes.close} aria-label="close gallery">
                    <Close />
                </IconButton>
            </Box>
        </Box>
    )
}

export default FullscreenImageView;